import React, { useEffect } from "react";
import hiasan1 from "../../Img/hiasan-3.webp";
import pria from "../../Img/pria.webp";
import wanita from "../../Img/wanita.webp";
import bg1 from "../../Img/bg1.webp";
import bgm1 from "../../Img/bgm1.webp";
import ornamenMobile from "../../Img/ornamen.webp";
import ornamenDesktop from "../../Img/ornamendesktop.webp";
// 👇 IMPORT FOTO LAN2 UNTUK BACKGROUND AYAT 👇
import lan2 from "../../Img/lan2.webp";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Couple() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1200,
    });
  }, []);

  return (
    <>
      <style>
        {`
          .couple-section {
            background-image: url(${bgm1});
            background-attachment: scroll;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 100%;
            position: relative;
            z-index: 1; 
          }

          @media (min-width: 768px) {
            .couple-section {
              background-image: url(${bg1});
              background-attachment: fixed;
            }
          }

          .couple-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 0.9) 100%);
            z-index: 2; 
          }

          .arch-frame {
            border-radius: 120px 120px 20px 20px;
            box-shadow: 0 10px 25px rgba(170, 142, 113, 0.2); 
            border: 6px solid #d4af37; 
            object-fit: cover;
            transition: transform 0.5s ease;
          }

          @keyframes floating {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }
          .animate-float {
            animation: floating 6s ease-in-out infinite;
          }
          .animate-float-delay {
            animation: floating 6s ease-in-out 3s infinite;
          }

          /* 👇 STYLE BARU UNTUK SECTION AYAT DENGAN FOTO LAN2 👇 */
          .quotes-section {
            background-image: url(${lan2});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 100%;
            min-height: 400px;
            position: relative;
            display: flex;
            align-items: flex-end; /* Teks berada di bawah */
          }

          /* Gradient Maroon transparan ke arah foto */
          .maroon-gradient-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(to top, 
                rgba(92, 20, 32, 1) 0%, 
                rgba(92, 20, 32, 0.8) 30%, 
                rgba(92, 20, 32, 0) 100%);
            z-index: 1;
          }
        `}
      </style>

      {/* SECTION MEMPELAI */}
      <div
        id="couple"
        className="couple-section flex flex-col justify-center items-center pt-32 pb-24 relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-full z-[4]">
          <img
            src={ornamenMobile}
            alt="Ornamen"
            className="w-full h-auto md:hidden block"
          />
          <img
            src={ornamenDesktop}
            alt="Ornamen"
            className="w-full h-auto hidden md:block"
          />
        </div>

        <div className="couple-overlay"></div>

        <div className="w-full max-w-6xl px-6 md:px-12 lg:px-20 relative z-[3] flex flex-col items-center">
          <div className="text-center mb-16 flex flex-col items-center">
            <img
              src={hiasan1}
              alt="hiasan1"
              className="w-[70px] mb-6"
              data-aos="zoom-in"
            />
            <h1
              className="text-xl md:text-2xl font-semibold arial mb-4 text-[#413327]"
              data-aos="fade-up"
            >
              "Tuhan Membuat Segala Sesuatu Indah Pada Waktunya"
            </h1>
            <p
              className="max-w-2xl text-center arial text-[#413327] text-sm md:text-base leading-relaxed"
              data-aos="fade-up"
            >
              Dengan penuh rasa syukur atas anugerah dan kasih setia Tuhan, kami
              bermaksud mengundang Bapak/Ibu/Saudara/i untuk menghadiri Ngunduh
              Mantu putra-putri kami :
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-center gap-12 md:gap-8 w-full">
            {/* PRIA */}
            <div className="flex flex-col items-center text-center">
              <div data-aos="zoom-in-up" className="relative mb-6">
                <img
                  src={pria}
                  alt="Pria"
                  loading="lazy"
                  className="w-[220px] h-[300px] md:w-[260px] md:h-[350px] arch-frame animate-float"
                />
              </div>
              <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#8a6e55] mb-2">
                Mempelai Pria
              </p>
              <h1 className="custom-font-2 text-4xl lg:text-5xl text-[#413327] mb-4">
                Alfanias Buala Waruwu
              </h1>
              <div className="border-t border-[#c5b5a1] w-16 my-3 mx-auto"></div>
              <p className="text-[#5c4a3d] text-sm md:text-base leading-relaxed">
                Putra dari <br />
                <span className="font-semibold text-[#413327]">
                  Bapak Pdt. Martinus Waruwu, S.Th
                </span>{" "}
                <br />
                <span className="font-semibold text-[#413327]">
                  & Ibu Surini
                </span>
              </p>
            </div>

            <div className="hidden md:flex justify-center items-center h-full">
              <span className="custom-font-2 text-7xl text-[#aa8e71] opacity-70 mt-10">
                &
              </span>
            </div>

            <div className="md:hidden flex justify-center items-center -my-6 z-10">
              <span className="bg-white px-4 rounded-full custom-font-2 text-5xl text-[#aa8e71] shadow-sm">
                &
              </span>
            </div>

            {/* WANITA */}
            <div className="flex flex-col items-center text-center">
              <div data-aos="zoom-in-up" className="relative mb-6">
                <img
                  src={wanita}
                  alt="Wanita"
                  loading="lazy"
                  className="w-[220px] h-[300px] md:w-[260px] md:h-[350px] arch-frame animate-float-delay"
                />
              </div>
              <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#8a6e55] mb-2">
                Mempelai Wanita
              </p>
              <h1 className="custom-font-2 text-4xl lg:text-5xl text-[#413327] mb-4">
                Ruri Crysta Damayanti
              </h1>
              <div className="border-t border-[#c5b5a1] w-16 my-3 mx-auto"></div>
              <p className="text-[#5c4a3d] text-sm md:text-base leading-relaxed">
                Putri dari <br />
                <span className="font-semibold text-[#413327]">
                  Bapak Kapten Inf. Rudi Harianto
                </span>{" "}
                <br />
                <span className="font-semibold text-[#413327]">
                  & Ibu Niken Pudji Lestari
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 👇 SECTION AYAT: BACKGROUND LAN2 DENGAN SUMBER AYAT DI BAWAH 👇 */}
      <div className="quotes-section overflow-hidden">
        {/* Lapisan Gradient Maroon (Gelap di bawah, Transparan di atas) */}
        <div className="maroon-gradient-overlay"></div>

        <div className="pt-32 pb-16 w-full max-w-4xl mx-auto px-8 relative z-10 flex flex-col items-center">
          {/* 1. KATA-KATA QUOTES (UKURAN SEDANG & ITALIC) */}
          <p
            data-aos="fade-up"
            className="text-center text-base md:text-lg font-medium tracking-wide leading-relaxed text-white/90 italic drop-shadow-lg mb-4"
            style={{ fontFamily: "'Georgia', serif" }}
          >
            "He prayed for her, she prayed for him and God smiled knowing that
            their names are already written next to each other."
          </p>

          {/* 2. SUMBER AYAT (UKURAN KECIL DI BAWAH) */}
          <h2
            data-aos="fade-up"
            data-aos-delay="200"
            className="text-center text-[10px] md:text-xs font-bold tracking-[0.3em] text-[#fcf6ba] uppercase opacity-80"
            style={{ fontFamily: "'Arial', sans-serif" }}
          >
            — MATTHEW 18:19 —
          </h2>
        </div>
      </div>
    </>
  );
}
